import React, { Component } from 'react'

import {
    TextArea,
    Form,
    Button,
    Dropdown,
    Label,
    Grid,
    Segment,
    Icon,
    Accordion,
    Checkbox,
    GridColumn
} from "semantic-ui-react";
import { Field, reduxForm} from 'redux-form'

import moment from 'moment';
import axios from 'axios'
//import licenseTypes from '../../common/licenseHelper'

import 'react-datepicker/dist/react-datepicker.css';
import {requiredField, validateEmail} from "../../common/clientValidators";

import KDatePicker from '../KDatePicker'
import KDropDown from '../KDropDown'
import KSearch from '../KSearch'
import _ from 'lodash'

const required = value => (value ? undefined : 'Required field');
const requiredList = array => (array && array.length > 0 ? undefined: 'Missing license type');

const requestLength = value => value.trim().length >= 578 ? undefined : 'Invalid length of license request  ';
const requestStart = value => value.trim().startsWith("----- BEGIN LICENSE REQUEST ----") ? undefined : "Missing proper ----- BEGIN .... header ";
const requestEnd = value => value.trim().endsWith("------ END LICENSE REQUEST -----") ? undefined : "Missing proper ------ END .... tail ";

const convertDate = (date) => {
    return date instanceof moment ? date.format('DD.MM.YYYY') : date;
};





// Parse a dropped request file. Two formats are supported:
//
//  (1) Plain text: the first line is the machine / license-holder id and the
//      rest is the BEGIN..END license-request block. We drop the first line and
//      keep the rest verbatim (line endings normalised only) so the web user can
//      fix any character the client may have dropped on export.
//
//  (2) JSON-ish: an object with "license-request", "email" and "license-type"
//      (often preceded by a "Computer ID:" header line). The license-request
//      value contains raw newlines, so it is not strict JSON; the fields are
//      extracted by regex and left otherwise untouched.
const parseRequestFile = (raw) => {
    const text = String(raw == null ? '' : raw).replace(/\r\n?/g, '\n');

    if (/"license-request"\s*:/.test(text)) {
        const grab = (key) => {
            const m = text.match(new RegExp('"' + key + '"\\s*:\\s*"([\\s\\S]*?)"\\s*(?:,|})'));
            return m ? m[1].trim() : undefined;
        };
        return {
            licenseRequest: grab('license-request') || '',
            email: grab('email'),
            licenseType: grab('license-type')
        };
    }

    // Plain format: drop the first line (holder id), keep the rest verbatim.
    const nl = text.indexOf('\n');
    return { licenseRequest: (nl === -1 ? '' : text.slice(nl + 1)).trim() };
};

const CustomTextArea = ({label, input, placeHolder, rows, width, onFile, meta : {touched, error}, ...rest}) => {
    const [dragOver, setDragOver] = React.useState(false);

    const onDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => {
            const parsed = parseRequestFile(ev.target.result);
            input.onChange(parsed.licenseRequest || '');
            // Let the parent prefill any extra fields (email, license type).
            if (onFile) onFile(parsed);
        };
        reader.readAsText(file);
    };

    return (
        <div onDrop={onDrop}
             onDragOver={(e) => { e.preventDefault(); if (!dragOver) setDragOver(true); }}
             onDragLeave={() => setDragOver(false)}
             style={dragOver ? {outline: '2px dashed #2185d0', outlineOffset: '2px', borderRadius: '4px'} : undefined}>
            {touched && error && <Label basic color='red' pointing='below'>{error}</Label>}
            <Form.Field {...input} label={label} control={TextArea} placeholder={placeHolder} rows={rows}
                        style={{fontFamily: 'Monospace'}} {...rest}/>
            <small style={{color: 'rgba(0,0,0,0.5)'}}>Tip: drag a request (.req) file here to fill this field automatically.</small>
        </div>
    );
};


const RenderInputField = ({input,  label, width, meta: { touched, error }, ...rest}) =>
    <React.Fragment>
        <Form.Field width={width}>
            <label>{label}</label>
            <input {...input} {...rest} />
            {touched && error && <Label  basic color='red' pointing>{error}</Label>}
        </Form.Field>
    </React.Fragment>



const RenderStatus = ({input,  label, width, meta: { touched, error }, ...rest}) =>
    <React.Fragment>
        <Icon name="warning"></Icon>
        <label>{label}</label>
    </React.Fragment>

function CustomCheckBox({input, ...rest}) {
    return <Checkbox checked={input.value} {...input} {...rest}></Checkbox>
}
class GeneratedLicenseInfo extends Component {
    constructor(props) {
        super(props);
        this.state = { results: [], allowedOptions: null, maxExpireDate: null, expireDisabled: false };
        this.prefillApplied = false;
    }

    componentDidMount() {
        // Load per-user entitlements (email -> company, allowed products, expiry)
        if (this.props.getLicenseAccess) this.props.getLicenseAccess();
        this.maybeApplyPrefill();
    }

    componentDidUpdate() {
        this.maybeApplyPrefill();
        this.enforceMaxExpire();
    }

    // Keep the expiry within the user's allowed ceiling. This also corrects the
    // initial default (e.g. +3 months) down to the latest allowed date once the
    // entitlement is known, so the field never shows a date beyond the allowance.
    enforceMaxExpire = () => {
        const max = this.state.maxExpireDate;
        const cur = this.props.currentExpire;
        if (!max || !cur) return;
        const curM = moment.isMoment(cur) ? cur : moment(cur, ['YYYY.MM.DD', 'DD.MM.YYYY', moment.ISO_8601], true);
        if (curM && curM.isValid() && curM.isAfter(moment(max))) {
            this.props.change('expire_date', moment(max));
        }
    }

    // When the wizard is opened pre-filled from a report row, run the entitlement
    // cascade once for the pre-set email (after license-access data has loaded).
    maybeApplyPrefill = () => {
        if (this.prefillApplied) return;
        const email = this.props.initialValues && this.props.initialValues.email;
        if (!email) return;
        if (!(this.props.licenseAccess && this.props.licenseAccess.length)) return;
        if (!this.entitlementFor(email)) return;
        this.prefillApplied = true;
        this.applyEmail(email);
    }

    // HMI-1: unique emails that have registered entitlements, as Search results.
    emailResults = (query) => {
        const rows = this.props.licenseAccess || [];
        const emails = [...new Set(rows.map(r => r.email).filter(Boolean))];
        const list = emails.map(email => ({ title: email }));
        if (!query) return list;
        const re = new RegExp(_.escapeRegExp(query), 'i');
        return list.filter(r => re.test(r.title));
    }

    // Look up a selected email's entitlement from the license-access data.
    entitlementFor = (email) => {
        const rows = (this.props.licenseAccess || []).filter(r => r.email === email);
        if (!rows.length) return null;
        const company = (rows.find(r => r.company) || {}).company || '';
        const fullname = (rows.find(r => r.fullname) || {}).fullname || '';
        const products = rows.map(r => Number(r.product_code)).filter(n => !isNaN(n));
        const expires = rows
            .map(r => moment(r.expire_date, 'DD.MM.YYYY'))
            .filter(m => m.isValid());
        // "one date per user": use the latest allowed expiry as the ceiling
        const maxExpire = expires.length ? moment.max(expires) : null;
        return { company, fullname, products, maxExpire };
    }

    onSearchChange = (e, data) => {
        this.setState({ results: this.emailResults(data.value) });
    }

    onResultSelect = (e, data) => {
        this.applyEmail(data.result.title);
    }

    // Prefill extra fields from a dropped JSON request file (email + license
    // type). The license-request text itself is set by the field's own onChange.
    onDroppedFile = (parsed) => {
        if (!parsed) return;
        if (parsed.email) {
            // Set the email first: applyEmail only sets it when the user has a
            // known entitlement, so this covers emails with no entitlement too.
            this.props.change('email', parsed.email);
            this.applyEmail(parsed.email);
        }
        if (parsed.licenseType != null && parsed.licenseType !== '') {
            const types = String(parsed.licenseType)
                .split(',')
                .map(s => Number(s.trim()))
                .filter(n => !isNaN(n));
            // Set after applyEmail so the file's license type wins over the
            // entitlement-based pruning.
            if (types.length) this.props.change('license_types', types);
        }
    }

    // Fill company/name, restrict licenses, and clamp/disable expiry for an email.
    applyEmail = (email) => {
        const ent = this.entitlementFor(email);
        if (!ent) {
            this.setState({ allowedOptions: null, maxExpireDate: null, expireDisabled: false });
            return;
        }
        this.props.change('email', email);
        // HMI-3: auto-fill name + company from the user's record
        this.props.change('fullName', ent.fullname);
        this.props.change('companyName', ent.company);
        // HMI-4: restrict license options to the allowed products.
        // "All packages" is a wildcard that grants every available license.
        const allowed = new Set(ent.products);
        const allPkgOpt = (this.props.productCodes || []).find(o => /all\s*packages/i.test(String(o.text)));
        const grantsAll = allPkgOpt ? allowed.has(Number(allPkgOpt.value)) : allowed.has(99);
        const allowedOptions = grantsAll
            ? (this.props.productCodes || [])
            : (this.props.productCodes || []).filter(o => allowed.has(Number(o.value)));
        // drop any already-selected licenses that are no longer allowed
        const allowedValues = new Set(allowedOptions.map(o => Number(o.value)));
        const current = this.props.currentLicenseTypes || [];
        const pruned = current.filter(v => allowedValues.has(Number(v)));
        if (pruned.length !== current.length) this.props.change('license_types', pruned);
        // HMI-5: clamp the current expiry down to the allowed ceiling
        if (ent.maxExpire && this.props.currentExpire &&
            moment(this.props.currentExpire).isAfter(ent.maxExpire)) {
            this.props.change('expire_date', ent.maxExpire);
        }
        // If the user's allowed expiry is already in the past, there's no valid
        // future date to pick, so disable the expire-date controls.
        const expireDisabled = !!(ent.maxExpire && moment(ent.maxExpire).isBefore(moment()));
        this.setState({ allowedOptions, maxExpireDate: ent.maxExpire, expireDisabled });
    }

    // HMI-5: keep any expiry change (manual or preset) within the allowed ceiling.
    clampExpire = (value) => {
        const max = this.state.maxExpireDate;
        if (max && value && moment(value).isAfter(moment(max))) return moment(max);
        return value;
    }

    onValidateRequest = (e) => {
        e.preventDefault();
    }

    // HMI-2: quick-set the expire date relative to today, clamped (HMI-5) to
    // the selected user's allowed expiry when one is known.
    setExpire = (amount, unit) => {
        let date = moment().add(amount, unit);
        const max = this.state.maxExpireDate;
        if (max && date.isAfter(moment(max))) date = moment(max);
        this.props.change('expire_date', date);
    }

    // A quick-set preset is only legal if the resulting date is within the user's
    // allowed expiry ceiling. When there is no known ceiling, all presets are legal.
    exceedsAllowance = (amount, unit) => {
        const max = this.state.maxExpireDate;
        return !!(max && moment().add(amount, unit).isAfter(moment(max)));
    }

    // Set the expiry to the latest date the user is allowed (their ceiling).
    setExpireToMax = () => {
        if (this.state.maxExpireDate) this.props.change('expire_date', moment(this.state.maxExpireDate));
    }

    handleSubmit = (data) => {

        return this.props.signLicense(convertDate(data.expire_date),
            data.license_types,
            data.licenseRequest,
            data.fullName,
            data.email,
            this.props.authInfo.username,
            data.companyName)
    }
    render() {
        const { error, handleSubmit, productCodes,initialValues } = this.props;
        //licenseTypes

         return (
            <Form onSubmit={handleSubmit(this.handleSubmit)} >
                <Grid padded>
                    <Grid.Row columns={1} centered>
                        <Grid.Column>
                            {/*<Form.Group width={2} >*/}
                            {/*    <Field name='license_format' label="Generate old license format" component={CustomCheckBox}*/}
                            {/*           onChange={this.props.toggleLicenseTypes}/>*/}

                            {/*</Form.Group>*/}


                            <Form.Group >
                                <Field name='expire_date' label="Expire date:" component={KDatePicker}
                                       minDate={moment()} validate={[requiredField]} normalize={this.clampExpire}
                                       disabled={this.state.expireDisabled}
                                       placeholder='Expire date' width={8}/>

                                <Field name='license_types' label='Select Licenses: ' component={KDropDown}
                                       multiple search selection options={this.state.allowedOptions || productCodes}
                                       placeholder='Select licenses' validate={[requiredList]} width={8}/>
                            </Form.Group>

                            <Form.Group>
                                <Form.Field width={8}>
                                    <label>Quick set expire date:</label>
                                    <Button.Group size='mini' basic>
                                        <Button type='button' disabled={this.state.expireDisabled || this.exceedsAllowance(1, 'months')} onClick={() => this.setExpire(1, 'months')}>+1 month</Button>
                                        <Button type='button' disabled={this.state.expireDisabled || this.exceedsAllowance(3, 'months')} onClick={() => this.setExpire(3, 'months')}>+3 months</Button>
                                        <Button type='button' disabled={this.state.expireDisabled || this.exceedsAllowance(1, 'years')} onClick={() => this.setExpire(1, 'years')}>+1 year</Button>
                                    </Button.Group>
                                    {/* When even +1 month exceeds the allowance, suggest the latest allowed date. */}
                                    {!this.state.expireDisabled && this.state.maxExpireDate && this.exceedsAllowance(1, 'months') &&
                                        <Button.Group size='mini' basic style={{ marginLeft: '0.5em' }}>
                                            <Button type='button' onClick={this.setExpireToMax}>
                                                Latest possible ({moment(this.state.maxExpireDate).format('YYYY.MM.DD')})
                                            </Button>
                                        </Button.Group>}
                                    {this.state.expireDisabled &&
                                        <Label basic color='red' pointing='left'>User's license allowance has expired</Label>}
                                    {!this.state.expireDisabled && this.state.maxExpireDate &&
                                        <Label basic color='grey' pointing='left'>Allowed until {moment(this.state.maxExpireDate).format('YYYY.MM.DD')}</Label>}
                                </Form.Field>
                            </Form.Group>

                            <Form.Group>
                                <Field name='fullName' label="Name:" component={RenderInputField}
                                       validate={[requiredField]} placeholder='Enter licensee name' width={8}/>

                                <Field name='email' label='Email: ' component={KSearch}
                                       placeHolder='Search existing email' autoComplete='off'
                                       onSearchChange={this.onSearchChange} onResultSelect={this.onResultSelect}
                                       results={this.state.results}
                                       validate={[requiredField, validateEmail]} width={8}/>

                            </Form.Group>

                            <Form.Group>
                                <Field name='companyName' label="Company name:" component={RenderInputField}
                                        placeholder='Company name'  width={16}/>

                            </Form.Group>

                            <Form.Group>
                                <Field name='licenseRequest' component={CustomTextArea} label='License request:'
                                       placeHolder='Paste in your license request here' rows={10} width={16}
                                       onFile={this.onDroppedFile}
                                       validate={[required, requestLength, requestStart, requestEnd]} style={{width: "320px", fontFamily: 'Monospace'}}/>
                                { error ? <div className="ui negative message">
                                    <div className="header">
                                        Error
                                    </div>
                                    <p>{error}</p>
                                </div> : null}

                                {/*<Grid>*/}
                                {/*    <Grid.Row>*/}
                                {/*        <Grid.Column  width={9}>*/}
                                {/*        </Grid.Column>*/}
                                {/*        <Grid.Column width={7}>*/}
                                {/*            { !this.props.invalid ? <React.Fragment>*/}
                                {/*                <div style={{height: "22px"}}/>*/}
                                {/*                <Button onClick={(e) => this.onValidateRequest(e)}>*/}
                                {/*                    Validate license*/}
                                {/*                </Button>*/}
                                {/*                <Segment secondary>*/}
                                {/*                    GeneratedLicenses request is valid.*/}
                                {/*                </Segment>*/}
                                {/*                <Segment inverted color="red">*/}
                                {/*                    You are using an old license format. Please consider to upgrade your software to a newer version.*/}
                                {/*                </Segment>*/}
                                {/*            </React.Fragment> : null}*/}
                                {/*         </Grid.Column>*/}
                                {/*    </Grid.Row>*/}
                                {/*</Grid>*/}
                            </Form.Group>


                        </Grid.Column>



                    </Grid.Row>
                    <Grid.Row columns={1} centered >
                        <Form.Button icon="right arrow" type="submit" labelPosition="right" content='Next' disabled={this.props.invalid} />
                    </Grid.Row>
                </Grid>
            </Form>

        )
    }


}


export default reduxForm({
    form: 'generatedLicenseInfo',
    enableReinitialize : true, // this is needed!!

})(GeneratedLicenseInfo);




